module.exports = __webpack_public_path__ + "static/img/12.e1faf4f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/1/sp/12.png
// module id = lQJ4
// module chunks = 0